import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { SharedModule } from '@modules/shared.module';
import { AssetCredentialStoreResourcesComponent } from '@pages/credential-stores/grid/asset-credential-store-resources.grid';
import { RobotCredentialStoreResourcesComponent } from '@pages/credential-stores/grid/robot-credential-store-resources.grid';
import { CredentialStoreModalComponent } from '@pages/credential-stores/modal/credential-store';
import { CredentialStoreDeleteModalComponent } from '@pages/credential-stores/modal/credential-store-delete/credential-store-delete.modal';
import {
    DynamicConfigurationFormComponent,
    GenericFormEntryComponent,
    SimpleMultiChoiceEntryComponent,
} from '@pages/credential-stores/modal/dynamic-configuration-form';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

const MODALS = [
    CredentialStoreModalComponent,
    CredentialStoreDeleteModalComponent,
];

const DYNAMIC_FORM_COMPONENTS = [
    DynamicConfigurationFormComponent,
    GenericFormEntryComponent,
    SimpleMultiChoiceEntryComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MatDialogModule,
        UiSuggestModule,
        UiAutofocusModule,
        UiNgLetModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
        UiGridModule,
        UiToggleSwitchModule,
    ],
    declarations: [
        ...MODALS,
        ...DYNAMIC_FORM_COMPONENTS,
        AssetCredentialStoreResourcesComponent,
        RobotCredentialStoreResourcesComponent,
    ],
    entryComponents: [
        ...MODALS,
        ...DYNAMIC_FORM_COMPONENTS,
    ],
})
export class CredentialStoresModalModule { }
